<template>
  <div class="sky-hc-content-analysis">
    <pagination-table
      ref="multipleTable"
      :data="dataList"
      :limit="limit"
      :total="count"
      :hasSearch="true"
      :page="page"
      :searchPlaceholder="$t('dataAnalysis.searchPlaceholder')"
      @search="handleSearchContent"
      @prevClick="handlePrevClick"
      @nextClick="handleNextClick"
      @sizeChange="handleSizeChange"
    >
      <template slot="columns">
        <el-table-column prop="title" :label="$t('dataAnalysis.fileName')"></el-table-column>
        <el-table-column prop="createTime" :label="$t('dataAnalysis.uploadTime')">
          <template slot-scope="scope">
            {{ date.format(scope.row.createTime, 'yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column prop="webClickCount" :label="$t('dataAnalysis.downloadNum')">
          <template slot-scope="scope">
            {{ scope.row.type === FILE_TYPE.QCOW ? scope.row.webClickCount : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="webClickCount" :label="$t('dataAnalysis.readNum')">
          <template slot-scope="scope">
            {{ scope.row.type === FILE_TYPE.PDF ? scope.row.webClickCount : '' }}
          </template>
        </el-table-column>
      </template>
    </pagination-table>
  </div>
</template>
<script>
import { TableColumn, Input } from 'element-ui'

import date from 'element-ui/lib/utils/date'

import { getFileAnalysisList } from '@/api/dataAnalysis'
import PaginationTable from '@/components/paginationTable'
import { FILE_TYPE } from '@/utils/enum'

export default {
  name: 'ContentAnalysis',
  components: {
    PaginationTable,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input
  },
  data() {
    return {
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      dataList: [],
      date,
      FILE_TYPE
    }
  },
  created() {
    this.handleGetDataAnalysisList()
  },
  methods: {
    handleSearchContent(keyword) {
      this.keyword = keyword
      this.handleGetDataAnalysisList()
    },
    handlePrevClick() {
      this.page--
      this.handleGetDataAnalysisList()
    },
    handleNextClick() {
      this.page++
      this.handleGetDataAnalysisList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetDataAnalysisList()
    },
    handleGetDataAnalysisList() {
      getFileAnalysisList({
        page: this.page,
        limit: this.limit,
        searchKeyword: this.keyword
      }).then(response => {
        this.dataList = response.data.content.itemArr
        this.count = response.data.content.total
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-content-analysis) {
  width: 100%;
  padding-top: 30px;
}
</style>
